import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Label = ({ children, className, htmlFor }) =>
  <label className={classNames('Label', className)} htmlFor={htmlFor}>
    {children}
  </label>;

Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  htmlFor: PropTypes.string.isRequired,
};

Label.defaultProps = {
  className: null,
};

export default Label;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Label/index.js